export default "__VITE_ASSET__C73QbXSH__"